import React from "react";
import BrandMark from "./BrandMark";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col relative">
      <header className="w-full">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <BrandMark />
          <a
            href="https://trylightbulb.com/offer"
            target="_blank"
            rel="noopener noreferrer"
            className="gl-ghost text-xs sm:text-sm px-3 sm:px-4 py-2 inline-flex"
            data-testid="header-offer-link"
          >
            Get Lightbulb
          </a>
        </div>
      </header>
      <main className="flex-1 w-full">{children}</main>
      <footer className="w-full">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 border-t border-[#1a221c] mt-12">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <p className="text-xs text-[#6c7770] max-w-xl leading-relaxed">
              Scores and figures are based on real sources we found, linked above. Not a guarantee of results.
            </p>
            <p className="text-xs text-[#6c7770]">
              Greenlight Score™ by{" "}
              <a className="gl-link" href="https://trylightbulb.com" target="_blank" rel="noopener noreferrer">
                Lightbulb
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
